import React from "react";
import {change, formValueSelector, reducer as formReducer, reduxForm , resetSection } from "redux-form";
import {combineReducers, createStore} from "redux";
import {connect, Provider} from "react-redux";
import {RAVDFinish, RAVDForm} from "../components/BaseForm";
import "../index.css"
import FormHandlers from "../FormHandlers";
import {DropDownMenu, DateDropDownMenu,CheckBox, InputField, ComplexDropDownMenu} from "../components/FormElements";
import "./index.css";
import {SelectModel} from "../components/ModelListContainer";
import oneSvg from "../images/1.svg"
import twoSvg from "../images/2.svg"
import threeSvg from "../images/3.svg"
import tickSvg from "../images/Tick.svg";
import SVG from 'react-inlinesvg';
import {YourDetailsNoPostcodeMarketing} from "../components/YourDetails"
import {RAVDValidator, transformVehicle, validateDealerForVirtualTestDrive} from "../util/Validators";
import {RequestATestDriveDirectCall, RequestAVirtualDemoDirectCall} from "../components/DTMDirectCalls";

const rootReducer = combineReducers({
    form: formReducer,
});


const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const SUBMISSION_URL = process.env.REACT_APP_RAVD_URL;
const VERSION = process.env.REACT_APP_VERSION_ID;
const DEALERS_URL = process.env.REACT_APP_VPC_DEALERS_API_URL;

class TransitionWrapper extends React.Component {

    render() {
        const props = this.props;
        return (<div className={`select-model-true your-details-true testdrive-true`}>{props.children}</div>)

    }
}

const FormTransitionWrapper = (props) => {

    const FormTransitionComponent = connect((state) => {
        const selector = formValueSelector(props.formName);
        return {
            formState: selector(state, 'formState'),
            firstname: selector(state, 'firstname'),
            lastname: selector(state, 'lastname'),
            email: selector(state, 'email'),
            postcode: selector(state, 'postcode'),
            phone: selector(state, 'phone'),
            'marketingOptIn': selector(state, 'marketingOptIn'),
            testdrivetiming: selector(state, 'testdrivetiming'),
            dealerfound: selector(state, 'dealerfound'),

            completed: selector(state, 'completed'),

        }
    })(reduxForm({form: props.formName})(TransitionWrapper));

    return <FormTransitionComponent {...props} />
};


function App(props) {
    const {brand, config , dealers} = props;
    const formName = props.formName || "fca-ravd";

    const handlers = FormHandlers(SUBMISSION_URL, brand, config, {
        onSubmit: async function (values, dispatch, props) {
            if (values) {
                const {vehicle, marketingOptIn, testdrivetimingdate, postcode, year, email , digitalData , testdrivetimingtime, availablenow} = values;
                RequestAVirtualDemoDirectCall(brand,config, true).complete(
                    vehicle, year || config[transformVehicle(vehicle)].year, postcode, availablenow , testdrivetimingdate,testdrivetimingtime, marketingOptIn,email, digitalData, window);
            }
            return {};
        },
        onSubmitSuccess: async function (results, dispatch, props) {
            dispatch(change(formName, 'completed', true));
            dispatch(change(formName, 'response', results));
            setTimeout(() => {
                if (window.parentIFrame) {
                    window.parentIFrame.moveToAnchor("#top");
                }
            }, 500);

        }
    } );

    return (
        <Provider store={store}>
            <a name="top" data-version={VERSION}/>

            <div className={`${brand.value} container-fluid pl-0 pr-0`}>
                <FormTransitionWrapper formName={formName}>

                    <RAVDForm id={'satd'} formName={formName} loader={props.loader}
                              handlePrePopulateModel={() => {
                              }}
                              componentWillMountCallback={async (p) => {
                                  return {}
                              }}
                              optionalConfig={{
                                  asyncChangeFields : ['postcode'],
                                  asyncValidate :  validateDealerForVirtualTestDrive,
                                  validate: (values) => {
                                      return RAVDValidator(values);
                                  },
                                  initialValues: {
                                      completed: false,
                                      brand: brand,
                                      models: props.models,
                                      availabledealers : config.virtualtestdrivedealers,
                                      'firstname': "",
                                      'lastname': "",
                                      'postcode': '',
                                      'email': '',
                                      'phone': '',
                                      'marketingOptIn': true,
                                      'vehicle': '',
                                      'eVar39': '',
                                      'GACLIENTID': '',
                                      'testdrivetiming': '',
                                      'loaddealer': false,
                                      'dealerfound': false,
                                      brandConfig: config,
                                      formState: {
                                          'selectModel': false,
                                      },
                                      availablenow : false
                                  }
                              }}
                              onSubmit={handlers.onSubmit}
                              onSubmitFail={handlers.onSubmitFail}
                              onSubmitSuccess={handlers.onSubmitSuccess}
                              isFormValid={(props) => {
                                  const {formValues} = props;
                                  if (formValues !== undefined) {
                                      const {vehicle, models,postcode , dealerfound , firstname , lastname , email , phone ,
                                          availablenow , testdrivetimingdate , testdrivetimingtime } = formValues;
                                      const m = models.map(i => i.toLowerCase().trim());
                                      const v = vehicle.toLowerCase().trim();
                                      let fieldsToValidate = [vehicle, firstname, lastname, email , phone];
                                      return /^[0-9]{4}$/.test(postcode) && dealerfound && fieldsToValidate.every((i) => i !== undefined && i.trim().length > 0) && m.includes(v) &&
                                          ( !availablenow ? testdrivetimingdate !== undefined && testdrivetimingtime !== undefined : true ) ;
                                  } else {
                                      return false;
                                  }
                              }}

                    >

                        <SelectModel formName={formName} icon={oneSvg} handleClick={() => {

                        }}/>
                        <hr className={'separator step-1'}/>
                        <RequestAVirtualDemo formName={formName} dealers={config.virtualtestdrivedealers} loader={props.loader} icon={twoSvg} handleClick={() => {

                        }}/>
                        <hr className={'separator step-2'}/>
                        <YourDetailsNoPostcodeMarketing formName={formName} icon={threeSvg}/>


                    </RAVDForm>

                </FormTransitionWrapper>
                <RAVDFinish formName={formName} data={"response"}/>


            </div>
        </Provider>
    )
}

function RequestAVirtualDemo(props) {
    const {formName, icon} = props;
    function Component(p) {
        const {testdrivetiming, postcode, dispatch, brand, dealer, loaddealer, handleClick , dealers , availablenow } = p;
        const isCompleted = [postcode, testdrivetiming].every((i) => i !== undefined && i.trim().length > 0) && dealer !== undefined;

        return (
            <div id={'testdrive'}
                 className={"testdrive col-12 col-lg-6 col-md-12 offset-lg-3 " + (isCompleted ? ` selected ` : ` `)}>
                <a name="testdrive"/>
                <div className={"d-flex justify-content-center section-heading"}>
                    {!isCompleted && <SVG src={icon}/>}
                    {isCompleted && <SVG src={tickSvg}/>}
                    <h4 className={"pl-1 pt-1"}>&nbsp;FIND A LOCAL DEALER</h4>
                </div>

                <div className="form-group">
                    <label>{"Are you available to contact now?"}</label>
                    <CheckBox
                        labelText={`Yes, I am available to be contacted as soon as possible`}
                        name={"availablenow"}/>
                </div>

                { <div className={availablenow ? `d-none` : `d-block`}>
                    <DateDropDownMenu type={"text"}
                                labelText={"Or Request your preferred date"} name={"testdrivetimingdate"} required={false} />
                </div>}

                {!availablenow && <DropDownMenu labelText={"Preferred time"} name={'testdrivetimingtime'} required={false}
                                                items={["09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
                                                    "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30"]}/>}

                <InputField labelText={"Your postcode"} name={"postcode"} type={"text"} required={false} placeholder={"E.g. 2000"}/>

                {loaddealer && <div className={'card border-0'}>
                    <div className="card-body">
                        <div className="card-text text-center">
                            <SVG src={props.loader}/>
                        </div>
                    </div>
                </div>}

                {dealer && <div className={"card"}>
                    <div className="card-body">
                        <div className="card-text">
                            <h4>{dealer.name}</h4>
                            <p>{dealer.address.line1} {dealer.address.city} {dealer.address.state} {dealer.address.postal_code} </p>
                        </div>
                    </div>
                </div>}

            </div>);
    }

    const RequestAVirtualDemoComponent = connect((state) => {
        const selector = formValueSelector(formName);

        return {
            testdrivetiming: selector(state, 'testdrivetiming'),
            postcode: selector(state, 'postcode'),
            brand: selector(state, 'brand'),
            loaddealer: selector(state, 'loaddealer'),
            availablenow: selector(state, 'availablenow'),
            'dealer': selector(state, 'dealer')
        }
    })(Component);

    return <RequestAVirtualDemoComponent {...props} />

}


export default App;
